import { SnackbarContentProps } from '@mui/material'
import MaterialSnackbar, { SnackbarCloseReason, SnackbarOrigin } from '@mui/material/Snackbar'
import React, { useState } from 'react'
import { createRoot } from 'react-dom/client'
import styles from './styles.module.scss'

interface SnackbarProps {
  anchorOrigin?: SnackbarOrigin
  autoHideDuration?: number | null
  defaultOpen?: boolean
  message: SnackbarContentProps['message']
  onClose?(event: Event | React.SyntheticEvent<any, Event>, reason: SnackbarCloseReason): void
}

export default function Snackbar({
  anchorOrigin,
  autoHideDuration,
  defaultOpen,
  message,
  onClose
}: SnackbarProps) {
  const [open, setOpen] = useState(defaultOpen || false)

  const handleClose: SnackbarProps['onClose'] = (event, reason) => {
    setOpen(false)
    if (onClose) onClose(event, reason)
  }

  return (
    <MaterialSnackbar
      ContentProps={{
        'aria-describedby': 'message',
        classes: { root: styles['th-snackbar-content'] }
      }}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      classes={{ root: styles['th-snackbar'] }}
      message={<span id='message'>{message}</span>}
      open={open}
      onClose={handleClose}
    />
  )
}

Snackbar.show = function ({
  message,
  anchorOrigin,
  autoHideDuration,
  onClose
}: SnackbarProps) {
  const rootElement = document.getElementById('__next') as HTMLElement
  const el = document.createElement('div')
  rootElement.appendChild(el)

  const root = createRoot(el)

  function handleClose(
    event: React.SyntheticEvent<any, Event>,
    reason: SnackbarCloseReason
  ) {
    root.unmount()
    el.parentNode?.removeChild(el)
    if (onClose) onClose(event, reason)
  }

  root.render(
    <Snackbar
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      defaultOpen
      message={message}
      onClose={handleClose}
    />
  )

  return el
}
